export const TOBACCO_RING_POSITION = {
  foot: 0,
  head: 1
};
